import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-main px-5 py-16 md:py-24" data-id="element-21" data-mp="vtflt34fihk8">
      <Reveal className="mx-auto max-w-3xl" data-id="element-22" data-mp="vqjl57175es3">
        <div className="mb-12 text-center" data-id="element-23" data-mp="qtjnnkiexkcl">
          <Eyebrow data-id="element-24" data-mp="qvw7k37qe4sa">Exklusiv dazu</Eyebrow>
          <h2 className="mt-5 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-25" data-mp="14t2jbdu1f380">
            <GiftIcon className="h-7 w-7 shrink-0 text-brand-orange" strokeWidth={1.5} aria-hidden="true" data-id="element-26" data-mp="ztpzl1ygqc9n" />
            6 exklusive Boni
          </h2>
          <p className="mt-4 text-sm text-brand-gray md:text-base" data-id="element-27" data-mp="19lm2cqbhuqk7">
            Im Wert von{' '}
            <span className="font-bold text-brand-navy" data-id="element-28" data-mp="1nkvglkg53alj">159 €</span> – für dich
            inklusive.
          </p>
        </div>
        <div className="space-y-4" data-id="element-29" data-mp="1jgdyrqtcb7de">
          {bonuses.map(bonus => <article key={bonus.title} className="flex items-center gap-4 rounded-xl border border-brand-line bg-brand-alt p-4 shadow-sm sm:gap-5 sm:p-5" data-id="element-30" data-mp="3prwk6rbmlxu8">
              <span className="h-[5.5rem] w-[4rem] shrink-0 rounded-md border border-brand-line bg-brand-dark" aria-hidden="true" data-id="element-31" data-mp="2k18v6u30jk0" />
              <div className="min-w-0 flex-1" data-id="element-32" data-mp="cklbodx91w4c">
                <h3 className="text-base font-bold leading-snug text-brand-navy" data-id="element-33" data-mp="chpdqplej7fw">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-brand-gray sm:text-sm" data-id="element-34" data-mp="lblq5corl5i4">
                  {bonus.description}
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-35" data-mp="qd1b74qxzc0i">
                <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-brand-gray" data-id="element-36" data-mp="vbcjhb1l9egm">
                  Wert
                </p>
                <p className="mt-1 font-display text-lg font-extrabold text-brand-orange" data-id="element-37" data-mp="1079xvbtakaqr">
                  {bonus.value}
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}